
import { Component, Mixins, Prop } from "vue-property-decorator";
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";

@Component({
  inheritAttrs: false
})
export default class Date extends Mixins(formMixin, formOptionsMixin, formValidationMixin) {
  localValue: any = null;

  @Prop({ default: false })
  invalid: boolean;

  mounted() {
    this.localValue = this.value;
  }

  reset() {
    this.localValue = "00:00";
  }
}
